var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInputClearDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99805,
    cy: 7,
    r: 7,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14904 9.11729C4.94762 9.3192 4.94773 9.64634 5.14928 9.84813C5.351 10.0501 5.6781 10.05 5.8797 9.8479L7.99675 7.72562L10.1165 9.84802C10.3182 10.0499 10.6453 10.05 10.847 9.84814C11.0487 9.64636 11.0488 9.31923 10.8472 9.1174L8.72649 6.99409L10.8331 4.88225C11.0345 4.68033 11.0344 4.3532 10.8329 4.15141C10.6312 3.94944 10.3041 3.94954 10.1025 4.15164L7.99631 6.263L5.89071 4.15479C5.68903 3.95286 5.36193 3.95281 5.16018 4.15468C4.95853 4.35645 4.95848 4.68358 5.16007 4.88542L7.26657 6.99454L5.14904 9.11729Z",
    fill: "#666666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputClearDark);
export default __webpack_public_path__ + "static/media/input__clear_dark.1cdd319c8742319046d4f8232bcd079b.svg";
export { ForwardRef as ReactComponent };